import React, { Component } from 'react';
import roundAddIcon from './../../../assets/plus.svg';
import ErrorMessage from '../../../components/Message/ErrorMessage/ErrorMessage';
import {Button,InputGroup,Input,InputGroupAddon,Modal,ModalBody} from 'reactstrap';

class InviteAdminModal extends Component {

  populateInvitationInputs = () => {
    const {initialInputCount} = this.props;
    return Array(initialInputCount).fill().map((e,i) => {
      return (
        <div className="row" key={i}>
          <div className="col-md-4 col-lg-4 mt20">
          <Input type="email" name="email"
              placeholder="e.g. jane@doe.com"
              onChange={({target}) => this.props.onInputChange(i,target)}
          />
          </div>
          <div className="col-md-4 col-lg-4 mt20">
            <Input type="text" name="firstName"
                placeholder="e.g. Jane"
                onChange={({target}) => this.props.onInputChange(i,target)}
            />
          </div>
          <div className="col-md-4 col-lg-4 mt20">
            <Input type="text" name="lastName"
                placeholder="e.g. Doe"
                onChange={({target}) => this.props.onInputChange(i,target)}
            />
          </div>
        </div>
      );
    })
  }




  render() { 
    const {modalError,errorMessage, isSubmit} = this.props;
    return ( 
      <div>
        <div className="pick-office-modal-body-title">
          Invite Admins to {this.props.selectedOfficeName}
        </div>
        {
          modalError? 
          <div className="mt20"><ErrorMessage message={errorMessage}/></div>
          : null
        }
        <div className="row mt20">
          <div className="col-md-4 col-lg-4 pick-office-col-title">
            Email
          </div>
          <div className="col-md-4 col-lg-4 pick-office-col-title">
            First Name <span className="optional-text">(Optional)</span>
          </div>
          <div className="col-md-4 col-lg-4 pick-office-col-title">
            Last Name <span className="optional-text">(Optional)</span>
          </div>
        </div>
        <div>
        {
          this.populateInvitationInputs()
        }
        </div>
        <div className="row mt20">
          <div className="col cursor-pointer" onClick={this.props.onAddMember}>
            <img style={{marginRight:'10px',marginTop:'-3px'}} src={roundAddIcon} height="20px" width="20px" />
            <a className="add-member-link">Add another</a>
          </div>
        </div>
        <div className="row mt20">
          <div className="col-lg-4 col-md-4">
            <Button color="primary" 
              style={{width:'100%'}}
              onClick={this.props.onInviteComplete}>
              <span style={{fontSize:'18px',lineHeight:'25px',fontWeight:600}}>Invite</span>
            </Button>
          </div>
          <div className="col-lg-3 col-md-3">
            <Button onClick={this.props.toggle} color="secondary-filled" style={{width:'100%'}}>
              <span style={{fontSize:'18px',lineHeight:'25px'}}>Cancel</span>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
 
export default InviteAdminModal;